import React, { createContext, useEffect, useState, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(sessionStorage.getItem('token'));
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const handleLogout = useCallback(() => {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('M_ComCode');
    sessionStorage.removeItem('session');
    setToken(null);
    alert('세션이 만료되었습니다. 다시 로그인해주세요.');
    navigate('/login');
  }, [navigate]); // ✅ navigate는 의존성에 포함

  useEffect(() => {
    if (!token) {
      setUser(null);
      return;
    }
    try {
      const decoded = jwtDecode(token);
      setUser(decoded);
      const expiresInMs = decoded.exp * 1000 - Date.now();

      if (expiresInMs <= 0) {
        handleLogout();
      } else {
        const timer = setTimeout(() => {
          handleLogout();
        }, expiresInMs);

        return () => clearTimeout(timer);
      }
    } catch {
      handleLogout();
    }
  }, [token, handleLogout]); // ✅ handleLogout 추가

  const handleLogin = (newToken) => {
    sessionStorage.setItem('token', newToken);
    setToken(newToken);
  };

  return (
    <AuthContext.Provider value={{ token, user, handleLogin, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};